import { defineStore, otto } from '@otto-ec/global-resources/nexus';
import type { SelectionState } from '@otto-ec/nexus-registry/selection';
import type { SelectionContextState } from '@shared/types/SelectionContext.ts';
import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';

function contextState(selection: SelectionState, page: TileListPageLayout): SelectionContextState {
    const pbk = page.context.searchContext?.pbk;
    return { selection: { ...selection, page: { ...selection.page } }, context: pbk ? { pbk } : {} };
}

function sameContext(a: SelectionContextState, b: SelectionContextState): boolean {
    return (
        a.context.pbk === b.context.pbk &&
        a.selection.rule === b.selection.rule &&
        a.selection.entryRule === b.selection.entryRule &&
        a.selection.url === b.selection.url &&
        a.selection.page.sortOrder === b.selection.page.sortOrder &&
        a.selection.page.offset === b.selection.page.offset &&
        a.selection.page.layout === b.selection.page.layout &&
        a.selection.page.comparisonId === b.selection.page.comparisonId
    );
}

export type SelectionContextProvider = {
    publish(selection: SelectionState, page: TileListPageLayout): void;
    stop(): void;
};

export function registerSelectionContext(
    selection: SelectionState,
    page: TileListPageLayout,
): SelectionContextProvider {
    let state = contextState(selection, page);
    const stop = otto.selectionContext.assignNamespace({ current: defineStore<SelectionContextState>(state) });
    return {
        publish(selection, page) {
            const next = contextState(selection, page);
            if (sameContext(state, next)) return;
            state = next;
            otto.selectionContext.current.emit(next, { retain: true });
        },
        stop,
    };
}
